import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { Button, Divider, Typography } from '@mui/material';
import { TimelineProps } from '../../../interfaces/props/SaudeOnline/LinhaTempo/TimelineProps';
import { capitalize } from "../../../utils/Capitalize";
import './styles.css';
import {
  sxBold,
  sxButtonReagendar,
  sxItalic,
  sxRegular,
  sxSemibold
} from './sxProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { faCalendar, IconDefinition } from '@fortawesome/pro-solid-svg-icons';

function CustomTimeline(props: TimelineProps){

  const accessibility = useAccessibility();

  const buildIcon = (icon: IconDefinition, backgroundColor: string) => {
    return (
      <div className="icon-background" style={{ backgroundColor: backgroundColor }}>
        <FontAwesomeIcon size="lg" icon={icon} />
      </div>
    );
  }

    return (
      <Timeline position="right">
        {
          props.showHoje &&
          <TimelineItem tabIndex={0}>
              <TimelineSeparator>
                <TimelineDot sx={{ margin: '0px', padding: '0px', borderStyle: 'none'}}>
                {
                  buildIcon(faCalendar, '#F98639')
                }
                </TimelineDot>
                <TimelineConnector sx={{ width: '1px' }}/>
              </TimelineSeparator>
              <TimelineContent sx={{ paddingTop: '100px', py: '10px', px: 2 }}>
                <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxBold, marginBottom: '8px'}}>Hoje</Typography>
                <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxItalic, marginBottom: '15px'}}>Nenhum atendimento para exibir</Typography>
                <Divider />
              </TimelineContent>
              <TimelineOppositeContent display="none"/>
          </TimelineItem>
        }
        {
          props.eventos.map((evento, i) =>
            <TimelineItem key={i} tabIndex={0}>
              <TimelineSeparator>
                <TimelineDot sx={{ margin: '0px', padding: '0px', borderStyle: 'none'}}>
                  {
                    buildIcon(evento.icon, evento.bgColor)
                  }
                </TimelineDot>
                <TimelineConnector sx={{ width: '1px' }}/>
              </TimelineSeparator>
              <TimelineContent sx={{ paddingTop: '10px', paddingBottom: '10px', px: 2 }}>
                <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxBold, marginBottom: '8px'}}>{evento.dataFormatada}</Typography>
                <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxSemibold, marginBottom: '8px'}}>{capitalize(evento.nomePrestador)}</Typography>
                <div className="descricao-container">
                  <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxRegular, marginBottom: '8px'}} >{evento.descricao}</Typography>
                 
                </div>
                
                <div style={{paddingBottom: '10px', paddingTop: '10px', marginBottom: '10px'}}>
                  {
                    evento.showAgendar &&
                    <Button variant='contained' sx={sxButtonReagendar} 
                      style={accessibility.buttonStyleAccessibility}
                      onClick={() => props.handleReagendarClicked(evento)}
                    >
                      <Typography style={accessibility.buttonTextStyleAccessibility}>Agendar novamente</Typography>
                    </Button>
                  }

                  {
                    evento.showContato &&
                    <button 
                      className='contato-button' 
                      onClick={() => { props.handleContatoSelected(evento) }}
                      style={accessibility.textStyleAccessibility}
                      aria-label={`ver contato de ${evento.nomePrestador}`}
                    >
                      ver contato
                    </button>
                  }
                
                  
              </div>        
                {
                  (i < props.eventos.length - 1) &&
                  <Divider />
                }
                
              </TimelineContent>
              <TimelineOppositeContent display="none"/>
          </TimelineItem>
        )}
      </Timeline>
    );
}

export default CustomTimeline;